module.exports = __webpack_public_path__ + "img/1@2x.36a3b2a1.png";